import { DateTime } from "luxon";

export const thousandsSeparator = (value) => new Intl.NumberFormat('en-US').format(value);

export const durationDisplay = (start, end, dateOnly = false) => {
  const formattedDateTime = (value) => {
    if (dateOnly) return DateTime.fromSQL(value).toFormat("LLL d, y");

    return DateTime.fromSQL(value).toFormat("LLL d, y H:mm");
  };

  return `${formattedDateTime(start)} - ${formattedDateTime(end)}`;
}

export const fieldRequiredErrorMessage = "This field is required.";

export const stampsPreset = [
  {
    label: "upload",
    icon: require("@/assets/images/icons/punch-card/stamps/upload.svg")
  },
  {
    label: "ellipse",
    icon: require("@/assets/images/icons/punch-card/stamps/ellipse.svg")
  },
  {
    label: "coffee",
    icon: require("@/assets/images/icons/punch-card/stamps/coffee.svg")
  },
  {
    label: "croissant",
    icon: require("@/assets/images/icons/punch-card/stamps/croissant.svg")
  },
  {
    label: "donut",
    icon: require("@/assets/images/icons/punch-card/stamps/donut.svg")
  },
  {
    label: "egg",
    icon: require("@/assets/images/icons/punch-card/stamps/egg.svg")
  },
  {
    label: "drumstick",
    icon: require("@/assets/images/icons/punch-card/stamps/drumstick.svg")
  },
  {
    label: "pizza",
    icon: require("@/assets/images/icons/punch-card/stamps/pizza.svg")
  },
  {
    label: "popcorn",
    icon: require("@/assets/images/icons/punch-card/stamps/popcorn.svg")
  }
];

export const isValidUrl = (url) => {
  const urlRegex = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

  return urlRegex.test(url);
};

export const existingPresets = stampsPreset.map(({ label }) => label).concat("custom");